jQuery(function ($) {
	function fieldMeta($input) {
		var order = $input.is('.ymd_slash, .ymd_dash, .ymd_dot') ? 'ymd' : 'dmy';
		var placeholder = $input.attr('placeholder') || '';
		var sep = '.';
		if (placeholder.indexOf('.') !== -1) {
			sep = '.';
		} else if (placeholder.indexOf('-') !== -1 || $input.is('.dmy_dash, .ymd_dash')) {
			sep = '-';
		} else if (placeholder.indexOf('/') !== -1 || $input.hasClass('dmy') || $input.hasClass('ymd_slash')) {
			sep = '/';
		}
		return { order: order, sep: sep };
	}

	function formatDigits(digits, sep, order) {
		digits = String(digits).replace(/\D/g, '').slice(0, 8);
		if (!digits) {
			return '';
		}
		if (order === 'ymd') {
			if (digits.length <= 4) {
				return digits;
			}
			if (digits.length <= 6) {
				return digits.slice(0, 4) + sep + digits.slice(4);
			}
			return digits.slice(0, 4) + sep + digits.slice(4, 6) + sep + digits.slice(6);
		}
		if (digits.length <= 2) {
			return digits;
		}
		if (digits.length <= 4) {
			return digits.slice(0, 2) + sep + digits.slice(2);
		}
		return digits.slice(0, 2) + sep + digits.slice(2, 4) + sep + digits.slice(4);
	}

	function digitsFromValue(value, order) {
		var raw = String(value).trim();
		var iso = raw.match(/^(\d{4})[.\-/](\d{1,2})[.\-/](\d{1,2})$/);
		if (iso && order === 'dmy') {
			var day = iso[3].length === 1 ? '0' + iso[3] : iso[3];
			var month = iso[2].length === 1 ? '0' + iso[2] : iso[2];
			return day + month + iso[1];
		}
		return raw.replace(/\D/g, '');
	}

	function caretFromDigitCount(formatted, count) {
		if (count <= 0) {
			return 0;
		}
		var seen = 0;
		for (var i = 0; i < formatted.length; i++) {
			if (/\d/.test(formatted.charAt(i))) {
				seen += 1;
			}
			if (seen >= count) {
				return i + 1;
			}
		}
		return formatted.length;
	}

	function bindDateMask($input) {
		if ($input.data('auravitaDateMask')) {
			return;
		}
		var meta = fieldMeta($input);
		$input.data('auravitaDateMask', true);
		$input.attr('data-date-sep', meta.sep);
		$input.attr('data-date-order', meta.order);
		if ($input.val()) {
			$input.val(formatDigits(digitsFromValue($input.val(), meta.order), meta.sep, meta.order));
		}
		$input.attr('data-prev-date', $input.val());

		$input.on('input', function (event) {
			var el = this;
			var sep = el.getAttribute('data-date-sep') || '.';
			var order = el.getAttribute('data-date-order') || 'dmy';
			var previous = el.getAttribute('data-prev-date') || '';
			var cursor = el.selectionStart || 0;
			var inputType = event.originalEvent && event.originalEvent.inputType;
			var digitsBefore;

			if (inputType === 'deleteContentBackward' && previous.charAt(cursor) === sep) {
				var prevDigits = previous.replace(/\D/g, '');
				var before = previous.slice(0, cursor).replace(/\D/g, '').length;
				var nextDigits =
					prevDigits.slice(0, Math.max(0, before - 1)) + prevDigits.slice(before);
				digitsBefore = Math.max(0, before - 1);
				var shortened = formatDigits(nextDigits, sep, order);
				el.value = shortened;
				el.setAttribute('data-prev-date', shortened);
				var shortPos = caretFromDigitCount(shortened, digitsBefore);
				el.setSelectionRange(shortPos, shortPos);
				return;
			}

			digitsBefore = el.value.slice(0, cursor).replace(/\D/g, '').length;
			var formatted = formatDigits(digitsFromValue(el.value, order), sep, order);
			el.setAttribute('data-prev-date', formatted);
			if (el.value === formatted) {
				return;
			}
			el.value = formatted;
			var pos = caretFromDigitCount(formatted, digitsBefore);
			el.setSelectionRange(pos, pos);
		});
	}

	function isBirthdayField($input) {
		var autocomplete = ($input.attr('autocomplete') || '').toLowerCase();
		if (autocomplete.indexOf('bday') !== -1) {
			return true;
		}
		var label = ($input.closest('.gfield').find('.gfield_label, label').first().text() || '').toLowerCase();
		return /geburt|birth/.test(label);
	}

	function keepContactAutofill($input) {
		if (!isBirthdayField($input)) {
			if (!$input.attr('inputmode')) {
				$input.attr('inputmode', 'numeric');
			}
			return;
		}
		$input.attr('autocomplete', 'bday');
		$input.attr('inputmode', 'numeric');
	}

	function keepPhoneAutofill() {
		$('.ginput_container_phone input, input[type="tel"]').each(function () {
			var $input = $(this);
			if ($input.attr('type') !== 'hidden') {
				$input.attr('type', 'tel');
			}
			$input.attr('autocomplete', 'tel');
			$input.attr('inputmode', 'tel');
		});
	}

	function disableDatepickers() {
		$('.gform-datepicker, .ginput_container_date input').each(function () {
			var $input = $(this);
			if ($input.hasClass('hasDatepicker') && $.fn.datepicker) {
				$input.datepicker('hide');
				$input.datepicker('destroy');
			}
			$input.off('click focus');
			$input.addClass('initialized');
			keepContactAutofill($input);
			bindDateMask($input);
		});
		keepPhoneAutofill();
		$('.ui-datepicker-trigger').remove();
		$('#ui-datepicker-div').hide();
	}

	disableDatepickers();
	var attempts = 0;
	var timer = window.setInterval(function () {
		disableDatepickers();
		attempts += 1;
		if (attempts >= 25) {
			window.clearInterval(timer);
		}
	}, 200);

	$(document).on('gform_post_render', function () {
		window.setTimeout(disableDatepickers, 0);
	});

	function visibleControls($form) {
		return $form.find('input, select, textarea, button').filter(function () {
			var el = this;
			if (el.disabled || el.type === 'hidden') {
				return false;
			}
			if ($(el).closest('.gform_validation_container, .gform_hidden, .gf_invisible').length) {
				return false;
			}
			return el.offsetParent !== null;
		});
	}

	function prepareEnterKey() {
		$('.gform_wrapper form').each(function () {
			visibleControls($(this)).each(function () {
				var type = (this.type || '').toLowerCase();
				if (
					this.tagName.toLowerCase() === 'textarea' ||
					type === 'submit' ||
					type === 'button' ||
					this.tagName.toLowerCase() === 'button'
				) {
					return;
				}
				this.setAttribute('enterkeyhint', 'next');
			});
		});
	}

	function nextControl(el) {
		var controls = visibleControls($(el).closest('form')).get();
		var index = controls.indexOf(el);
		return index >= 0 ? controls[index + 1] : null;
	}

	prepareEnterKey();
	$(document).on('keydown', '.gform_wrapper form input, .gform_wrapper form select', function (event) {
		if (event.key !== 'Enter' && event.keyCode !== 13) {
			return;
		}
		var type = (this.type || '').toLowerCase();
		if (type === 'submit' || type === 'button' || type === 'checkbox' || type === 'radio' || type === 'file') {
			return;
		}

		var next = nextControl(this);
		if (!next) {
			return;
		}

		event.preventDefault();
		window.setTimeout(function () {
			next.focus();
		}, 0);
	});

	$(document).on('gform_post_render', function () {
		window.setTimeout(prepareEnterKey, 0);
	});

	var lastTypedAt = 0;

	function isAutofillTarget(el) {
		if (!el || !el.closest || !el.closest('.gform_wrapper form')) {
			return false;
		}
		var type = (el.type || '').toLowerCase();
		if (type && type !== 'text' && type !== 'email' && type !== 'tel') {
			return false;
		}
		var hint = (el.getAttribute('autocomplete') || '').toLowerCase();
		return /given-name|family-name|additional-name|honorific|email|tel|bday|\bname\b/.test(hint);
	}

	// iOS Safari blurs the field after autofill, which closes the keyboard.
	// A single claim loop holds focus on the target while Safari settles.
	var claimToken = 0;
	var settleTimer = null;
	var lastFilled = null;

	function claimField(target) {
		var token = ++claimToken;
		var deadline = Date.now() + 450;
		(function attempt() {
			if (token !== claimToken) {
				return;
			}
			if (document.activeElement !== target) {
				target.focus();
				try {
					if (typeof target.setSelectionRange === 'function') {
						var len = (target.value || '').length;
						target.setSelectionRange(len, len);
					}
				} catch (err) {}
			}
			if (Date.now() < deadline) {
				window.requestAnimationFrame(attempt);
			}
		})();
	}

	// Safari fills grouped fields one after another, so wait for the batch
	// to finish and then move to the first field still empty.
	function firstEmptyAfter(el) {
		var controls = visibleControls($(el).closest('form')).get();
		for (var i = controls.indexOf(el) + 1; i < controls.length; i++) {
			var control = controls[i];
			var type = (control.type || '').toLowerCase();
			if (type === 'submit' || type === 'button' || control.tagName.toLowerCase() === 'button') {
				return null;
			}
			if (!(control.value || '').trim()) {
				return control;
			}
		}
		return null;
	}

	document.addEventListener('keydown', function () {
		lastTypedAt = Date.now();
	}, true);

	document.addEventListener(
		'input',
		function (event) {
			var el = event.target;
			if (!isAutofillTarget(el)) {
				return;
			}
			var previous = el.dataset.lastValue || '';
			var value = el.value || '';
			el.dataset.lastValue = value;

			var typing = Date.now() - lastTypedAt < 200;
			var jumped = value.length - previous.length > 1;
			if (typing || !jumped) {
				return;
			}

			claimToken++;
			lastFilled = el;
			window.clearTimeout(settleTimer);
			settleTimer = window.setTimeout(function () {
				var target = lastFilled && firstEmptyAfter(lastFilled);
				if (target) {
					claimField(target);
				}
			}, 120);
		},
		true
	);
});
